import { useContext } from 'react';
import type { AgentInfo } from '@/api/types';
import { AgentContext, type AgentContextValue } from './agent-context';

export function useSession(): AgentContextValue {
  const context = useContext(AgentContext);
  if (!context) throw new Error('useSession must be used inside AgentProvider');
  return context;
}

// For pages behind RequireAgent: the key and the agent are guaranteed present.
export function useAgent(): { key: string; agent: AgentInfo; signOut(): void } {
  const { session, signOut } = useSession();
  if (session.status !== 'signed-in') throw new Error('useAgent must be used behind RequireAgent');
  return { key: session.key, agent: session.agent, signOut };
}
